export default "__VITE_ASSET__CsL1G_Za__";